module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [(_vm.total > 0) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "gender",
    attrs: {
      "title": 'Gender',
      "path": "demographics.gender",
      "options": _vm.get(_vm.filters, 'gender')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "age",
    attrs: {
      "title": 'Age',
      "path": "demographics.age",
      "options": _vm.get(_vm.filters, 'age')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "race",
    attrs: {
      "title": 'Race',
      "path": "demographics.ethnicity",
      "options": _vm.get(_vm.filters, 'ethnicity')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "language",
    attrs: {
      "title": 'Language',
      "virtualListSize": 25,
      "isLong": true,
      "path": "demographics.language",
      "options": _vm.get(_vm.filters, 'language')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('filter-group', {
    ref: "location",
    attrs: {
      "title": 'Location',
      "isLong": true,
      "path": "demographics.location",
      "options": _vm.get(_vm.filters, 'location')
    },
    on: {
      "change": _vm.handleFilterChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('filter-group', {
    ref: "identifier",
    attrs: {
      "title": 'Contact Details',
      "options": _vm.get(_vm.filters, 'contact'),
      "isLong": true,
      "valueKey": "id",
      "labelKey": "title",
      "path": "identifiers"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.title))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('channels-filter', {
    ref: "channel",
    attrs: {
      "title": 'Channels used',
      "options": _vm.get(_vm.filters, 'channel'),
      "isLong": true,
      "valueKey": "id",
      "path": "meta.channel",
      "labelKey": "handle"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.handle))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('date-range-filter', {
    ref: "engaged",
    attrs: {
      "title": 'Engaged'
    },
    on: {
      "change": _vm.handleFilterChange
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('filter-group', {
    ref: "show",
    attrs: {
      "title": 'During the shows',
      "options": _vm.get(_vm.filters, 'show'),
      "chunk": (_vm.get(_vm.filters, 'show') || []).length > 1,
      "valueKey": "id",
      "labelKey": "title",
      "path": "meta.show_id"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(slotProps) {
        return [_c('span', {
          staticClass: "option"
        }, [_vm._v(_vm._s(slotProps.option.title))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-118329cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/DemographicsFilter.vue
// module id = 3145
// module chunks = 3